import { React, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Card from "./Card";

const ProfilePage = () => {
  const [tabIndex, setTabIndex] = useState(0);
  console.log(tabIndex);
  return (
    <div className="profile-container">
      <div className="container-wrapper">
        <div className="profile-header">
          <div className="profile-header-wrapper">
            <div className="profile-cover-img">
              <img src="./images/dummyCover.png" alt="profile cover image" />
            </div>
            <div className="profile-img">
              <div className="profile-img-wrapper">
                <img src="./images/dummyProfile.jpg" alt="profile image " />
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="266"
                height="132"
                fill="none"
                viewBox="0 0 266 132"
              >
                <path
                  fill="#fff"
                  d="M265.5 101c0 62-65 10.5-137.5 10.5S.5 156.005.5 100.5c28.5 0 29.93-19.465 32.598-28.5C45.385 30.376 83.895 0 129.5 0c45.605 0 84.115 30.376 96.402 72 2.667 9.035 7.098 31 39.598 29Z"
                />
              </svg>
            </div>
            <div className="profile-followers">
              <div className="profile-followers-wrapper">
                <div className="followers follow ">
                  <span>12.3k</span>
                  <span>Followers</span>
                </div>
                <div className="following follow">
                  <span>300</span>
                  <span>Following</span>
                </div>
              </div>
            </div>
            <div className="profile-username">
              <div className="profile-username-wrapper">
                <h2>Xettri Aleen</h2>
                <p>
                  Passionate about frontend and design, loves open source
                  technology.
                </p>
                <div className="buttons">
                  <button>
                    {" "}
                    <span class="hover"></span>
                    <div>Follow</div>
                  </button>
                  <button>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="#EA4D88"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="M10.117 17.987H2.883"
                        opacity=".4"
                      />
                      <path
                        stroke="#EA4D88"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="M21.118 17.987a2.88 2.88 0 1 1-5.76 0 2.88 2.88 0 0 1 5.76 0Z"
                        clip-rule="evenodd"
                      />
                      <path
                        stroke="#EA4D88"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="M13.883 6.262h7.235"
                        opacity=".4"
                      />
                      <path
                        stroke="#EA4D88"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="M2.883 6.262a2.88 2.88 0 1 0 5.76 0 2.88 2.88 0 1 0-5.76 0Z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="profile-body">
          <Tabs
            selectedIndex={tabIndex}
            onSelect={(index) => setTabIndex(index)}
          >
            <div className="profile-tab">
              <div className="profile-tab-wrapper">
                <TabList>
                  <Tab className={`${!tabIndex ? "activeTab" : ""}`}>
                    <svg
                      className="menuIconMain"
                      xmlns="http://www.w3.org/2000/svg"
                      width="27"
                      height="27"
                      fill="none"
                      viewBox="0 0 27 27"
                    >
                      <path
                        stroke="#171717"
                        className="menuIconChild"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="M23.861 8.887v9.169c0 3.397-2.126 5.794-5.524 5.794h-9.73c-3.398 0-5.513-2.397-5.513-5.794V8.887c0-3.397 2.126-5.792 5.512-5.792h9.731c3.398 0 5.524 2.395 5.524 5.792Z"
                        clip-rule="evenodd"
                      />
                      <path
                        stroke="#171717"
                        className="menuIconChild"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="m5.941 18.486 1.72-1.815a1.58 1.58 0 0 1 2.287-.009l.995 1.016a1.612 1.612 0 0 0 2.398-.105l2.507-3.05c.72-.877 2.04-.93 2.83-.117l2.335 2.41"
                        opacity=".4"
                      />
                      <path
                        stroke="#171717"
                        className="menuIconChild"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="M11.603 10.276a1.973 1.973 0 1 1-3.944 0 1.973 1.973 0 0 1 3.944 0Z"
                        clip-rule="evenodd"
                        opacity=".4"
                      />
                    </svg>
                  </Tab>
                  <hr />
                  <Tab className={`${tabIndex ? "activeTab" : ""}`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="27"
                      height="27"
                      fill="none"
                      viewBox="0 0 27 27"
                      className="menuIconMain"
                    >
                      <path
                        stroke="#171717"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="M13.123 20.96 6.45 24.616a1.112 1.112 0 0 1-1.483-.443v0a1.174 1.174 0 0 1-.134-.525V7.45c0-3.09 2.111-4.325 5.15-4.325h7.135c2.945 0 5.149 1.154 5.149 4.12v16.403a1.102 1.102 0 0 1-1.102 1.102 1.216 1.216 0 0 1-.535-.134l-6.714-3.655a.834.834 0 0 0-.793 0Z"
                        clip-rule="evenodd"
                        className="menuIconChild"
                      />
                      <path
                        stroke="#171717"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="M9.416 10.488h8.207"
                        opacity=".4"
                        className="menuIconChild"
                      />
                    </svg>
                  </Tab>
                </TabList>
              </div>
            </div>

            <div className="profile-tab-panel">
              <div className="profile-tab-panel-wrapper">
                <hr />
                {/*  for photos tab panel */}
                <TabPanel className={`profile-tab-panel-container photos`}>
                  {/* looping images reusable card */}
                  <Card
                    image="./images/dummyItems/dummyItems1.png"
                    likes={20}
                    comment={20}
                  />

                  <Card
                    image="./images/dummyItems/dummyItems2.png"
                    likes={20}
                    comment={20}
                  />

                  <Card
                    image="./images/dummyItems/dummyItems3.png"
                    likes={20}
                    comment={20}
                  />

                  <Card
                    image="./images/dummyItems/dummyItems4.png"
                    likes={20}
                    comment={20}
                  />

                  <Card
                    image="./images/dummyItems/dummyItems5.png"
                    likes={20}
                    comment={20}
                  />

                  <Card
                    image="./images/dummyItems/dummyItems6.png"
                    likes={20}
                    comment={20}
                  />

                  <Card
                    image="./images/dummyItems/dummyItems7.png"
                    likes={20}
                    comment={20}
                  />

                  <Card
                    image="./images/dummyItems/dummyItems8.png"
                    likes={20}
                    comment={20}
                  />

                  <Card
                    image="./images/dummyItems/dummyItems1.png"
                    likes={20}
                    comment={20}
                  />
                </TabPanel>
                {/*  for saved tab panel */}
                <TabPanel className={`profile-tab-panel-container saved`}>
                  {/* looping images reusable card */}
                  <Card
                    image="./images/dummyItems/dummyItems8.png"
                    likes={20}
                    comment={20}
                  />

                  <Card
                    image="./images/dummyItems/dummyItems7.png"
                    likes={20}
                    comment={20}
                  />

                  <Card
                    image="./images/dummyItems/dummyItems6.png"
                    likes={20}
                    comment={20}
                  />

                  <Card
                    image="./images/dummyItems/dummyItems5.png"
                    likes={20}
                    comment={20}
                  />

                  <Card
                    image="./images/dummyItems/dummyItems4.png"
                    likes={20}
                    comment={20}
                  />

                  <Card
                    image="./images/dummyItems/dummyItems3.png"
                    likes={20}
                    comment={20}
                  />

                  <Card
                    image="./images/dummyItems/dummyItems2.png"
                    likes={20}
                    comment={20}
                  />

                  <Card
                    image="./images/dummyItems/dummyItems1.png"
                    likes={20}
                    comment={20}
                  />

                  <Card
                    image="./images/dummyItems/dummyItems8.png"
                    likes={20}
                    comment={20}
                  />
                </TabPanel>
              </div>
            </div>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
